module.exports = __webpack_public_path__ + "img/2.463a6217.png";